import { defineStore, getActivePinia, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'

const API_REST_ADD_ISSUE = '/api/report'

export const useBugReportStore = defineStore('bugreport', {
    state: () => ({
        inAction: false,
    }),
    actions: {
        async sendBugReport ({ text, type, subject, email, }) {
            try {
                if (this.inAction) {
                    return
                }
                this.inAction = true

                let activePinia = getActivePinia()
                let appUiStore = useAppUiStore(activePinia)

                let data = new FormData()
                data.append('type', type)
                data.append('text', text)
                data.append('subject', subject)
                data.append('email', email)
                data.append('lastRoutes', JSON.stringify(appUiStore.lastRoutes))
                data.append('aktRoute', location.pathname)

                let headers = {
                    'x-silent-request': true,
                    ...getDefaultHeaders({}),
                }

                delete headers['Content-Type']

                // Api-Request senden
                await fetch({
                    url: `${API_REST_ADD_ISSUE}`,
                    options: {
                        method: 'POST',
                        headers: headers,
                        body: data,
                    },
                    loading: false,
                })
            } finally {
                this.inAction = false
            }
        },
    },
})
